import { useTranslation } from "react-i18next";
import type { SidebarFooterProps } from "../types";
import { APP_VERSION } from "@/constants/appVersion";
import { getCodingCloudLogo } from "@/config/brandAssets";
import { trackCodingCloudLinkClick } from "../sidebarAnalytics";

const CODING_CLOUD_URL = "https://codingcloud.online";

// Firma discreta al pie del menú de apps (Daniel, 30-oct): «Producto
// desarrollado por» + el logo de Coding Cloud, en gris hasta pasar el cursor.
// Antes decía «App Credits» y, arriba, un aviso verde de desarrollo a la medida.
export function SidebarFooter({ isDarkMode }: SidebarFooterProps) {
  const { t } = useTranslation("common");
  const muted = isDarkMode ? "text-gray-500" : "text-gray-400";

  return (
    <div className={`px-3 pt-2 pb-2.5 flex flex-col items-center gap-0.5 border-t ${isDarkMode ? "border-white/10" : "border-black/[0.06]"}`}>
      <a
        href={CODING_CLOUD_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackCodingCloudLinkClick()}
        className="group flex items-center gap-1 opacity-70 hover:opacity-100 transition-opacity duration-200"
      >
        <span className={`text-[11px] ${muted}`}>{t("appsSidebar.productBy", "Producto desarrollado por")}</span>
        {/* El PNG trae aire arriba y el lema «Tailor Made Software» abajo, que a
            este tamaño es una mancha: el contenedor recorta ambos. */}
        <span className="block h-[22px] overflow-hidden">
          <img
            src={getCodingCloudLogo(isDarkMode)}
            alt="Coding Cloud"
            draggable={false}
            className="h-8 w-auto -mt-[4px] grayscale group-hover:grayscale-0 transition-[filter] duration-200 select-none"
          />
        </span>
      </a>
      <p className={`text-[10px] ${muted}`}>App Suite v{APP_VERSION} · © {new Date().getFullYear()}</p>
    </div>
  );
}
